import P from '../../pages';
import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { defaultMessages } from '../../../../libs/i18n/default';
import FormHeader from './FormHeader';
import Redirector from './Redirector';
import Button from 'react-bootstrap/lib/Button';
import ReactMarkdown from 'react-markdown';
import Tick from 'react-icons/lib/fa/check-circle';
import ReactOnRails from 'react-on-rails'
import ButtonGroup from './ButtonGroup';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import FormControl from 'react-bootstrap/lib/FormControl';

class Conclusion extends React.Component {
  constructor() {
    super();
    this.state = {
      password: '',
      password_confirmation: '',
      validations: {},
    };
    this.back = this.back.bind(this);
    this.submitPassword = this.submitPassword.bind(this);
    this.conclusionContent = this.conclusionContent.bind(this);
    this.formControlClass = this.formControlClass.bind(this);
    this.formIcon = this.formIcon.bind(this);
    this.updatePassword = this.updatePassword.bind(this);
    this.updateValidations = this.updateValidations.bind(this);
    this.submitPasswordButton = this.submitPasswordButton.bind(this);
    this.dashBoardLink = this.dashBoardLink.bind(this);
    this.trainingLink = this.trainingLink.bind(this);
  }

  back(e){
    e.preventDefault()
    this.props.onGoBack()
  }

  submitPassword(e){
    e.preventDefault()
    this.props.submitPassword({
      authenticity_token: ReactOnRails.authenticityToken(),
      password: this.state.password
    })
  }

  submitPasswordButton(){
    return !(
      this.state.validations &&
      this.state.validations.password &&
      this.state.validations.password_confirmation
    )
  }

  dashBoardLink(e){
    e.preventDefault();
    this.props.onWizardCompletion({
      authenticity_token: ReactOnRails.authenticityToken(),
      redirect_url: this.props.lobby_url
    })
  }

  trainingLink(e){
    e.preventDefault();
    this.props.onWizardCompletion({
      authenticity_token: ReactOnRails.authenticityToken(),
      redirect_url: `${this.props.lobby_url}/hosts/training`
    })
  }

  formControlClass(ref){
    if (this.state && this.state.validations){
      if (this.state.validations[ref]==undefined){
        return 'form-group';
      }else if(this.state.validations[ref]){
        return 'form-group has-feedback has-success';
      }else{
        return 'form-group has-feedback has-error';
      }
    }else{
      return 'form-group has-feedback has-error';
    }
  }

  formIcon(ref, extraClass){
    var klass;
    if (this.state && this.state.validations && this.state.validations[ref]!=undefined){
      if (this.state.validations[ref]){
        klass = 'check-circle';
      }else{
        klass = 'times-circle';
      }
    }
    if (klass){
      return(
        <span className={`form-control-feedback ${extraClass==undefined ? '' : extraClass}`}>
          <i className={`fa fa-${klass} fa-2x`}></i>
        </span>
      );
    }
  }

  updatePassword(e) {
    let key = e.target.id
    let val = e.target.value
    let v = this.validPasswordFormat(val);
    if (key == 'password'){
      this.updateValidations(key, v);
      this.setState({password: val})
      if (this.state.password_confirmation){
        let v2 = this.validPasswordFormat(this.state.password_confirmation)
        v2 = this.state.password_confirmation == val ? v2 : false
        this.updateValidations('password_confirmation', v2);
      }
    } else {
      v = val == this.state.password ? v : false
      this.updateValidations(key, v);
      this.setState({password_confirmation: val})
    }
  }

  updateValidations(key, value){
    var v = this.state.validations;
    v[key] = value;
    this.setState({validations: v});
  }

  validPasswordFormat(password){
    var regexp = new RegExp(/^(?=.*?[a-z])(?=.*?[0-9]).{6,}$/); //six characters including at least 1 number
    return regexp.test(password);
  }

  conclusionContent(){
    const { formatMessage } = this.props.intl;
    const content = this.props.content;
    return(
      this.props.user.password_not_set ?
        <div style={{textAlign: 'center'}}>
          <ReactMarkdown source={content.pages.conclusion.body_no_password}/>
          <FormGroup className={this.formControlClass('password')} >
            {this.formIcon('password')}
            <FormControl id="password"
              placeholder={formatMessage(defaultMessages.clientHostPagesRegisterPlaceholdersPassword)}
              type="password"
              componentClass="input"
              onChange={this.updatePassword}
              style={{textAlign: 'center', width: '100%'}}/>
          </FormGroup>
          <FormGroup className={this.formControlClass('password_confirmation')} >
            {this.formIcon('password_confirmation')}
            <FormControl id="password_confirmation"
              placeholder='Retype your password'
              type="password"
              componentClass="input"
              onChange={this.updatePassword}
              style={{textAlign: 'center', width: '100%'}}/>
          </FormGroup>
          <Button type="submit" onClick={this.submitPassword} disabled={this.submitPasswordButton()} className="btn btn-primary">{formatMessage(defaultMessages.clientHostPagesConclusionButtonsSetPassword)}</Button>
        </div>
      : <div>
          <ReactMarkdown source={content.pages.conclusion.body}/>
          <div className="conclusion-buttons text-center">
            <div>
              <Button type="submit" className='btn-primary' onClick={this.trainingLink}>{formatMessage(defaultMessages.clientHostPagesConclusionButtonsTraining)}</Button>
            </div>
            <div>
              <Button type="submit" className='btn-primary' onClick={this.dashBoardLink}>{formatMessage(defaultMessages.clientHostPagesConclusionButtonsDashboard)}</Button>
            </div>
          </div>
        </div>
    )
  }

  render(){
    const thisPage = P.CONCLUSION_PAGE;
    return (
      <div id={thisPage} className='profile'>
        <Redirector this_page={thisPage} page={this.props.page}/>
        <form>
        <div className="text-center">
          <div className="conclusion-icon"><h1><Tick /></h1></div>
        </div>
        <FormHeader title={this.props.content.pages.conclusion.title}/>
        {this.conclusionContent()}
        <ButtonGroup
          backFunc={this.back}
          intl={this.props.intl}
          page={thisPage}
          user={this.props.user} />
        </form>
      </div>
    );
  }
};

Conclusion.propTypes = {
   onGoBack: PropTypes.func,
   page: PropTypes.string,
   intl: PropTypes.object,
   content: PropTypes.object
};

export default injectIntl(Conclusion);
